<ng-container *transloco="let t; read: 'login'">
  <div class="p-d-flex p-flex-column p-jc-center p-ai-center" style="height: 100vh;">
    <p-card header="{{ t('header') }}" role="main" class="login-card">

      <app-lang-selector></app-lang-selector>
      <p-messages [(value)]="messages"></p-messages>

      <app-loader [loading]="loading === true"></app-loader>

      <ng-container *ngIf="loading !== true">

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" role="form">

          <ng-container *ngIf="mode === LoginMode.AcList">
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon"><i class="pi pi-user"></i></span>
              <input type="text" pInputText [formControl]="loginForm.get('email')" placeholder="{{ t('labels.email') }}" aria-label="{{ t('labels.email') }}" class="autofocus">
            </span>

            <span class="p-inputgroup p-mt-2">
              <span class="p-inputgroup-addon"><i class="pi pi-key"></i></span>
              <input type="password" pPassword [formControl]="loginForm.get('password')" placeholder="{{ t('labels.password') }}" [feedback]="false" aria-label="{{ t('labels.password') }}">
            </span>

            <div class="p-grid p-mt-4">
              <div class="p-col-8" *ngIf="ssoActive === true">
                <button pButton type="button" (click)="gotoSSO()" label="{{ t('sso_login') }}" class="p-button-secondary p-button-outlined" [disabled]="busy === true"></button>
              </div>
              <div class="p-col-4 p-text-right" [ngClass]="{'p-col-12': ssoActive !== true}">
                <button pButton type="submit" [label]="(mode === LoginMode.Login) ? t('go_into') : t('login')" icon="{{ (busy === true) ? 'pi pi-spinner' : 'pi pi-sign-in' }}" [disabled]="busy === true"></button>
              </div>
            </div>

            <p class="p-mt-5" [innerHtml]="t('hint_candidate_observer')"></p>
            <hr>
            <p>
              <span [innerHtml]="t('hint_password')"></span><a [routerLink]="['/password']">{{ t('hint_password_link') }}</a>
            </p>
          </ng-container>

          <div *ngIf="mode === LoginMode.Login" class="list-container">
            <app-ac-selector [acs]="acs" [loading]="busy" (selected)="selectAc($event)" (cancelled)="cancelAcList($event)"></app-ac-selector>
          </div>

        </form>
      </ng-container>

    </p-card>

    <p class="p-text-center version">{{ t('version') }} {{ version }}</p>

    <p class="p-text-center p-mt-4 sublink"><a href="/admin">{{ t('to_planner') }}<i class="pi pi-angle-right p-ml-1"></i></a></p>

  </div>
</ng-container>
